module.exports = __webpack_public_path__ + "img/1484675093.35eeff91.jpg";